var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"center-center",attrs:{"icon":"","x-large":""},on:{"click":_vm.$attrs.trigger}},[_c('v-icon',[_vm._v("mdi-reload")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }